"use strict";
var Observable_1 = require('../../Observable');
var reduce_1 = require('../../operator/reduce');
Observable_1.Observable.prototype.reduce = reduce_1.reduce;
//# sourceMappingURL=reduce.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/reduce.js
// module id = 1384
// module chunks = 9